import React from "react";
import "../../css/components/loaders/InlineSpinner.css";

const InlineSpinner = ({ text = "Please wait..." }) => {
    return (
        <div className="inline-spinner-container">
            <div className="spinner"></div>
            {text && <p className="spinner-text">{text}</p>}
        </div>
    );
};

export default InlineSpinner;
